<div [formGroup]="formValidationGroup">
  <input type="text"
    [id]="validationIdentifier"
    [formControlName]="validationIdentifier"
    class="form-control"
    [title]="datafield.InfoText"
    [readOnly]="isAlwaysEditable ? false : !isEditable"
    [attr.maxlength]="datafield.DataLength"
    [ngModel]="$safeNavigationMigration(datafield?.Value)"
    (ngModelChange)="datafield.Value = $event; notifyValueChanged(datafield);" />
    @if (!isValid) {
      <div class="error">{{ errorText }}</div>
    }
  </div>
